"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_1 = require("@ethersproject/bignumber");
const ethers_1 = require("ethers");
const base_1 = require("../base");
const constant_1 = require("../constant");
const util_1 = require("../util");
class SupplyModule extends base_1.TectonicSDKModule {
    async mint(tTokenAddress, amount) {
        if (tTokenAddress !== this.getContractByName('TEther').address) {
            const tToken = this.getContractByAddress(tTokenAddress);
            return (0, util_1.wrapSdkTransaction)(tToken.mint(bignumber_1.BigNumber.from(amount)));
        }
        else {
            const tEther = this.getContractByAddress(tTokenAddress);
            return (0, util_1.wrapSdkTransaction)(tEther.mint({ value: bignumber_1.BigNumber.from(amount) }));
        }
    }
    async suppliedAmountOfUser(tTokenAddress, supplierAddress) {
        const tToken = this.getContractByAddress(tTokenAddress);
        return await tToken.balanceOf(supplierAddress);
    }
    async supplyRatePerBlock(tTokenAddress) {
        const tToken = this.getContractByAddress(tTokenAddress);
        return await tToken.supplyRatePerBlock();
    }
    async reserves(tTokenAddress) {
        //returns total amount of underlying ERC20/native coin with the decimals
        const tToken = this.getContractByAddress(tTokenAddress);
        return await tToken.totalReserves();
    }
    async reserveFactor(tTokenAddress) {
        //returns percentage number, e.g. 20.05% will be returned as 20.05
        const tToken = this.getContractByAddress(tTokenAddress);
        const reserveFactorMantissa = await tToken.reserveFactorMantissa();
        return (Math.round(reserveFactorMantissa
            .mul(100000) // 5 digits precision before rounding. otherwise the 5h digit will be truncated instead of rounded.
            .div(bignumber_1.BigNumber.from(constant_1.TectonicConst.ETH_MANTISSA))
            .toNumber() / 10) / // rounded to 4 digits integer.
            100); //become a percentage number
    }
    async totalSuppliedAmountInMarket(tTokenAddress) {
        const tToken = this.getContractByAddress(tTokenAddress);
        return await tToken.totalSupply();
    }
    async suppliedUnderlyingAmountOfUser(tTokenAddress, supplierAddress) {
        const tToken = this.getContractByAddress(tTokenAddress);
        return await tToken.callStatic.balanceOfUnderlying(supplierAddress);
    }
    async totalSuppliedUnderlyingAmountInMarket(tTokenAddress) {
        const tToken = this.getContractByAddress(tTokenAddress);
        const exchangeRateCurrent = await tToken.callStatic.exchangeRateCurrent();
        const totalSupply = await tToken.totalSupply();
        return exchangeRateCurrent.mul(totalSupply).div(constant_1.TectonicConst.ETH_MANTISSA);
    }
    async exchangeRate(tTokenAddress) {
        //to keep the precicion we return the 1e18 format, frontEnd need to divide TectonicConst.ETH_MANTISSA
        //also the rate is based on native erc20 decimals.
        //for example. exchange rate between CUSDT to USDT is 215877647014339
        // 215877647014339 / 1e18 = 0.000215877647014339
        // since all C/TTokens are 8 decimals, USDT is 6 decimals,
        // 0.000215877647014339 * Math.Pow(10, 8-6) = 0.0215877647014339
        // so we can show on the UI 1 USDT = 1 / 0.0215877647014339 = 46.322535650649283 TUSDT
        // So the formula should be 1 / ( exchangeRate * Math.Pow(10, TToken.decimals) / Math.Pow(10, erc20.decimals) /  TectonicConst.ETH_MANTISSA)
        const tToken = this.getContractByAddress(tTokenAddress);
        return await tToken.callStatic.exchangeRateCurrent();
    }
    async tTokenSupplyAmountOfUser(walletAddress, tTokenAddress) {
        const ITToken = this.getContractByAddress(tTokenAddress);
        return await ITToken.balanceOf(walletAddress);
    }
    async supplyApy(tTokenAddress) {
        const tToken = this.getContractByAddress(tTokenAddress);
        // The current supply rate as an unsigned integer, scaled by 1e18.
        const supplyRate = await tToken.supplyRatePerBlock();
        const dailyYieldRate = 1 +
            Number(ethers_1.ethers.utils.formatUnits(supplyRate.mul(bignumber_1.BigNumber.from(constant_1.TectonicConst.BLOCKS_PER_DAY))));
        const annualYieldRate = (Math.pow(dailyYieldRate, constant_1.TectonicConst.DAYS_PER_YEAR) - 1) * 10000;
        //updated to percentage number with 4 digits precision. same as other functions returning percentage number.
        //e.g. 20.05% will be returned as 20.05
        return Math.round(annualYieldRate) / 100;
    }
    async enableCollateral(tTokenAddress) {
        const tCore = this.getTectonicCore();
        return (0, util_1.wrapSdkTransaction)(tCore.enterMarkets([tTokenAddress]));
    }
    async disableCollateral(tTokenAddress) {
        const tCore = this.getTectonicCore();
        return (0, util_1.wrapSdkTransaction)(tCore.exitMarket(tTokenAddress));
    }
    async checkCollateralEnabled(tTokenAddress, walletAddress) {
        const tCore = this.getTectonicCore();
        return tCore.checkMembership(walletAddress, tTokenAddress);
    }
    async redeemAll(tTokenAddress, walletAddress) {
        if (tTokenAddress !== this.getContractByName('TEther').address) {
            const cErc20 = this.getContractByAddress(tTokenAddress);
            const suppliedAmount = await cErc20.balanceOf(walletAddress);
            return (0, util_1.wrapSdkTransaction)(cErc20.redeem(suppliedAmount));
        }
        else {
            const cEther = this.getContractByAddress(tTokenAddress);
            const suppliedAmount = await cEther.balanceOf(walletAddress);
            return (0, util_1.wrapSdkTransaction)(cEther.redeem(suppliedAmount));
        }
    }
    async redeemSome(tTokenAddress, amountToRedeem) {
        if (tTokenAddress !== this.getContractByName('TEther').address) {
            const cErc20 = this.getContractByAddress(tTokenAddress);
            return (0, util_1.wrapSdkTransaction)(cErc20.redeemUnderlying(amountToRedeem));
        }
        else {
            const cEther = this.getContractByAddress(tTokenAddress);
            return (0, util_1.wrapSdkTransaction)(cEther.redeemUnderlying(amountToRedeem));
        }
    }
}
exports.default = SupplyModule;
//# sourceMappingURL=supply.js.map